import React from 'react'
import { Card, GroupButton } from '@tecsinapse/cortex-react'
import { Produto } from '../components/produto'
import { Migracao } from '../components/migracao'
import { Sincronizacao } from '../components/sincronizacao'
import { AccessControl } from '@/core/utils/access-control'
import { TipoUsuario } from '@/core/enums/tipo-usuario'
import { t } from '@lingui/core/macro'

enum Tabs {
  PRODUTO = 'PRODUTO',
  MIGRACAO = 'MIGRACAO',
  SINCRONIZACAO = 'SINCRONIZACAO'
}

const SwitchTabs = ({ tab }: { tab: Tabs }) => {
  switch (tab) {
    case Tabs.MIGRACAO:
      return <Migracao />
    case Tabs.SINCRONIZACAO:
      return <Sincronizacao />
    case Tabs.PRODUTO:
      return <Produto />
  }
}

export const SuperAdmin = () => {
  const optionList = [
    {
      value: {
        nameEnum: Tabs.PRODUTO,
        title: t`Produto`
      }
    },
    {
      value: {
        nameEnum: Tabs.MIGRACAO,
        title: t`Migração`
      }
    },
    {
      value: {
        nameEnum: Tabs.SINCRONIZACAO,
        title: t`Sincronização`
      }
    }
  ]

  const [currentTab, setCurrentTab] = React.useState(optionList[0].value)

  return (
    <div className={'flex justify-center h-[60vh]'}>
      <AccessControl allowedUserTypes={[TipoUsuario.TECSINAPSE]}>
        <Card className={'mt-deca h-fit w-[50%]'}>
          <div className={'flex justify-center mb-kilo'}>
            <GroupButton
              value={currentTab}
              options={optionList}
              renderKey={option => String(option?.title)}
              renderOption={option => String(option?.title)}
              onChange={op => setCurrentTab(op)}
            />
          </div>

          <SwitchTabs tab={currentTab.nameEnum} />
        </Card>
      </AccessControl>
    </div>
  )
}
